<!-- 模块- 已核销-->
<template>
<div>
  <van-pull-refresh v-model="down_loading" @refresh="pulldown">
    <span v-if="data.length > 0">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadMore">

        <!-- 商品列表 -->
        <div class="goods" v-for="(item, index) in data" :key="index">
          <!-- 积分商品左边图片 -->
          <van-image v-if="item.img_data.length>0" width="25%" :src="item.img_data[0].url" />
          <van-image v-else style="width: 25%;height: 0;padding-bottom: 25%;" src="">
            <template v-slot:error>暂无封面</template>
          </van-image>
          <!-- 积分商品右边内容说明 -->
          <van-row class="goods_info" style="width:60%">
            <van-col span="24">{{ item.name }}</van-col>
          </van-row>
        </div>

      </van-list>
    </span>
    <van-empty v-else description="暂无记录" />
  </van-pull-refresh>
</div>

</template>

<style lang="scss" scoped>
  .goods {
    position: relative;
    display: flex;
    justify-content: space-around;
    margin:0 0 15px;
    padding:15px 5px;
    background:#fff;
  }
  .goods_info{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .van-list{
    padding: 10px;
  }
  .icon {
    width: 35px;
    height: 35px;
  }
  .show{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 10px;
  }
  .yxq{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
</style>
<script>

export default {
  data () {
    return {
      site: [],
      showNum: false,
      code: '',
      dhTime: '',
      page: 1,
      size: 15,
      data: [],
      sel_site: {},
      ky_site: [],
      loading: false,
      finished: false,
      down_loading: false
    }
  },
  created () {
    this.get_data()
  },
  methods: {

    // 获取数据
    get_data () {
      let data = {
        page: this.page,
        size: this.size,
        type: 1,
        status: 2
      }
      this.ax(this, 'wx_user_coupons', data, (res) => {
        if (res.err_num === 0) {
          this.page = res.data.page
          this.data = this.data.concat(res.data.data)

          this.loading = false
          this.down_loading = false

          // 判断是否还有更多
          if (res.data.data.length < this.size) {
            this.finished = true
          }
        }
      })
    },
    // 上拉加载更多
    loadMore () {
      this.page += 1
      this.get_data()
    },
    // 下拉刷新
    pulldown () {
      this.finished = false
      this.page = 1
      this.data = []
      this.get_data()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inte_store/write_on.vue